import { request } from "../libs";

function fetchServersDetails(domain) {
	return request(
		`/server/${domain}`,
		{ method: "GET" }
	)
		.then(res => res.json());
}

export default fetchServersDetails;



// WEBPACK FOOTER //
// ./src/api/fetch-servers-details.js